import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP9BudgetCappedOvw202603: FaireAdPerformancePeriodEntity = {
  token: "perf_p9_budget_capped_ovw_202603",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2026-03-01",
  endDate: "2026-03-31",
  impressions: 53641,
  clicks: 1141,
  adsSpendDollars: 3441,
  budgetDollars: 4900,
  salesDollars: 25718,
  bestEstimateRoas: 7.47,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.7,
  newCustomersAcquired: 43,
  reorderConversions: 35,
  dataAvailableAtDate: "2026-04-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
